import {Injectable} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';
import {take} from 'rxjs/operators';
import {LogoutComponent} from '../components/popups/logout/logout.component';
import {SnackbarService} from './snackbar.service';
import firebase from 'firebase/compat/app';
import {SharedService} from './shared.service';
import {EventLogItemType, EventLogSource} from '../models/EventLog';
import {UserService} from './user.service';
import {AdminService} from './admin.service';
import {IdService} from 'src/app/services/id.service';
import {ProjectService} from 'src/app/services/project.service';
import {Timestamp} from 'firebase/firestore';
import User = firebase.User;


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user: User;

  constructor(
    public afAuth: AngularFireAuth,
    public router: Router,
    private snackbarservice: SnackbarService,
    private dialog: MatDialog,
    private sharedservice: SharedService,
    private userservice: UserService,
    private adminservice: AdminService,
    private idservice: IdService,
    private projectservice: ProjectService
  ) {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.user = user;
        localStorage.setItem('user', JSON.stringify(this.user));
      } else {
        localStorage.setItem('user', null);
      }
    });
  }

  async login(email: string, password: string) {
    return await this.afAuth.signInWithEmailAndPassword(
      email,
      password
    )
      .then((success) => {
        return success;
      })
      .catch((err) => {
        throw err;
      });
  }

  async checkUserAndUpdateIfMatching(firebaseUser: firebase.User, reload: boolean = false) {
    const user = await this.userservice.getUserByFirebaseUserId(firebaseUser);
    if (user) {
      user.firebaseUser = {
        email: firebaseUser.email,
        displayName: firebaseUser.displayName,
        uid: firebaseUser.uid,
      };
      await this.userservice.updateUser(user).then(() => {
          this.sharedservice.user.next(user);
          if (reload) {
            window.location.reload();
          }
        }
      ).catch(err => {
        console.error('Error updating user:', err);
        this.snackbarservice.openSnackBar('Kunne ikke oppdatere bruker', 'Ok');
      });
      const projectId = this.idservice.projectId();
      if (projectId) {
        await this.projectservice.updateProject({triggerUpdate: Timestamp.fromDate(new Date())}).catch(err => {
          console.error('Error updating project:', err);
          this.snackbarservice.openSnackBar('Kunne ikke oppdatere prosjekt', 'Ok');
        });
      }
    } else {
      const errorMessage = 'Bruker funnet i autentiseringsserver, men ikke i APG. Ta kontakt med APG admin';
      await this.adminservice.buildEventLogItemAndAddToEventLog({
        type: EventLogItemType.USER_NOT_FOUND,
        source: EventLogSource.APG_MAIN,
        email: this.user.email,
        errorMessage
      });
      this.snackbarservice.openSnackBar(errorMessage, 'dismiss', 10000);
    }
  }


// async loginWithToken(token: string) {
  //   const result = await this.afAuth.signInWithCustomToken(token);
  //   // window.location.reload();
  //   // this.router.navigate(['admin/list']);
  // }

  // async register(email: string, password: string) {
  //   const result = await this.afAuth.createUserWithEmailAndPassword(email, password)
  //   this.sendEmailVerification();
  // }

  // async sendEmailVerification() {
  //   await this.afAuth.currentUser.sendEmailVerification();
  //   this.router.navigate(['admin/verify-email']);
  // }

  async sendPasswordResetEmail(passwordResetEmail: string) {
    return await this.afAuth.sendPasswordResetEmail(passwordResetEmail, {url: 'https://apg.aventi.no'});
  }

  logoutConfirm() {
    const dialogRef = this.dialog.open(LogoutComponent, {
      backdropClass: 'blur-dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.sharedservice.isLoading.next([
          true,
          'Logger av...',
          [''],
        ]);
        this.logout()
          .then(() => {
          })
          .catch((err) => {
            console.error(err.message);
          });
      }
    });
  }

  async logout() {
    await this.afAuth.signOut();
    localStorage.removeItem('user');
    window.location.reload();
  }

  // isLoggedIn(): boolean {
  //   const user = JSON.parse(localStorage.getItem('user'));
  //   console.log('isLoggedIn:', user);
  //   return user !== null;
  // }

  // isAuthenticated(): boolean {
  //   this.afAuth.authState
  //     .pipe(first())
  //     .pipe(
  //       tap((user) => {
  //         if (user) {
  //           console.log('isAuthenticated:', user);
  //           return true;
  //         } else {
  //           // do something else
  //           return false;
  //         }
  //       })
  //     )
  //     .subscribe();
  //   // return false;
  // }

  async updatePassword(oldPass: string, newPass: string): Promise<string> {
    return new Promise<string>((resolve) => {
      this.afAuth.user.pipe(take(1)).subscribe((user) => {
        const credentials = firebase.auth.EmailAuthProvider.credential(
          user.email,
          oldPass
        );
        user
          .reauthenticateWithCredential(credentials)
          .then(() => {
            console.log('Reauthentification successful');
            user
              .updatePassword(newPass)
              .then(() => {
                console.log('Password updated');
                this.snackbarservice.openSnackBar('Passord oppdatert', 'Takk');
                resolve('success');
                return 'success';
              })
              .catch((changepassErr) => {
                console.log(changepassErr);
                if (changepassErr.code === 'auth/user-token-expired') {
                  this.snackbarservice.openSnackBar(
                    'For mange forsøk. Logger ut...',
                    ''
                  );
                  resolve('user-token-expired');
                  return 'user-token-expired';
                } else {
                  resolve(changepassErr.code);
                  return changepassErr.code;
                }
              });
          })
          .catch((reauthenticateErr) => {
            if (reauthenticateErr.code === 'auth/wrong-password') {
              console.log(reauthenticateErr);
              this.snackbarservice.openSnackBar(
                'Gammelt passord stemmer ikke',
                'Ok'
              );
            }
            resolve('wrong password');
            return 'wrong password';
          });
      });
    });
  }
}
